var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroFourthIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7094 34.745H15.5249V17.8612V1H29.7094H43.8939V17.8612",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0017 20.4248V27.5505H55.128",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1123 18.3828H30.3901V56.2126H57.2386V25.4858L50.1123 18.3828Z",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9973 41.6436H52.6315",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9973 45.9775H52.6315",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9973 50.335H52.6315",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.4286 37.1274C37.5846 38.4663 41.1251 36.6508 43.3719 33.0425C45.6187 29.457 45.7095 25.4403 43.5535 24.1014C41.3974 22.7625 37.857 24.5779 35.6102 28.1862C33.3633 31.7717 33.2725 35.7884 35.4286 37.1274Z",
    fill: "#591F7E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3518 23.852C40.6029 23.852 39.7859 24.1243 38.9461 24.6916C37.6071 25.5766 36.4043 27.0517 35.6099 28.8218C33.9986 32.3393 34.4071 36.1291 36.495 37.0822C37.4936 37.536 38.7192 37.3318 39.9901 36.4922C41.3291 35.6071 42.532 34.132 43.3263 32.362C44.9604 28.7764 44.5745 25.0774 42.4412 24.1016C42.1007 23.9427 41.7376 23.8746 41.3518 23.8746M37.6071 38.3984C37.0624 38.3984 36.5404 38.2849 36.0638 38.058C33.3858 36.8325 32.7503 32.4754 34.634 28.3679C35.5191 26.4163 36.8582 24.7824 38.356 23.7839C39.9447 22.74 41.5561 22.4903 42.8951 23.1031C45.6185 24.3512 46.2313 28.5949 44.3249 32.7931C43.4398 34.7448 42.1007 36.3787 40.6028 37.3772C39.5816 38.058 38.5603 38.3984 37.6071 38.3984Z",
    fill: "#591F7E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3518 23.852C40.6029 23.852 39.7859 24.1243 38.9461 24.6916C37.6071 25.5766 36.4043 27.0517 35.6099 28.8218C33.9986 32.3393 34.4071 36.1291 36.495 37.0822C37.4936 37.536 38.7192 37.3318 39.9901 36.4922C41.3291 35.6071 42.532 34.132 43.3263 32.362C44.9604 28.7764 44.5745 25.0774 42.4412 24.1016C42.1007 23.9427 41.7376 23.8746 41.3518 23.8746M37.6071 38.3984C37.0624 38.3984 36.5404 38.2849 36.0638 38.058C33.3858 36.8325 32.7503 32.4754 34.634 28.3679C35.5191 26.4163 36.8582 24.7824 38.356 23.7839C39.9447 22.74 41.5561 22.4903 42.8951 23.1031C45.6185 24.3512 46.2313 28.5949 44.3249 32.7931C43.4398 34.7448 42.1007 36.3787 40.6028 37.3772C39.5816 38.058 38.5603 38.3984 37.6071 38.3984Z",
    stroke: "#591F7E",
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2909 38.1033C36.2909 38.1033 36.2456 38.1033 36.2229 38.1033C35.9278 38.0806 35.7009 37.8083 35.7463 37.5133C35.769 37.2864 36.3363 31.9988 37.7888 29.7295C38.3108 28.8898 38.9236 28.3225 39.5137 27.7779C40.535 26.8247 41.5108 25.917 42.169 23.4434C42.2371 23.1484 42.5548 22.9896 42.8272 23.0576C43.1222 23.1257 43.281 23.4434 43.2129 23.7157C42.464 26.4843 41.2839 27.5736 40.2399 28.5494C39.6725 29.0714 39.1505 29.5706 38.6966 30.2741C37.403 32.3392 36.8356 37.5587 36.8356 37.6041C36.8129 37.8764 36.5633 38.0806 36.2909 38.0806",
    fill: "#591F7E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2909 38.1033C36.2909 38.1033 36.2456 38.1033 36.2229 38.1033C35.9278 38.0806 35.7009 37.8083 35.7463 37.5133C35.769 37.2864 36.3363 31.9988 37.7888 29.7295C38.3108 28.8898 38.9236 28.3225 39.5137 27.7779C40.535 26.8247 41.5108 25.917 42.169 23.4434C42.2371 23.1484 42.5548 22.9896 42.8272 23.0576C43.1222 23.1257 43.281 23.4434 43.2129 23.7157C42.464 26.4843 41.2839 27.5736 40.2399 28.5494C39.6725 29.0714 39.1505 29.5706 38.6966 30.2741C37.403 32.3392 36.8356 37.5587 36.8356 37.6041C36.8129 37.8764 36.5633 38.0806 36.2909 38.0806",
    stroke: "#591F7E",
    strokeWidth: 0.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3223 10.5547H55.9677",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.199 7.74023L56.6259 10.5542L53.199 13.3682",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9846 10.5547H37.6301",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.884 7.74023L38.2883 10.5542L34.884 13.3682",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.25H21.471",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1 22.7627H21.471",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1 29.2764H21.471",
    stroke: "#591F7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroFourthIcon03);
export default __webpack_public_path__ + "static/media/intro_fourth_icon_03.370eda350b2e5b4b403eccc67eda4836.svg";
export { ForwardRef as ReactComponent };